module.exports = __webpack_public_path__ + "static/img/agent1.dc9f6571.png";